function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#575D7C",
  d: "M1.75 0C.793 0 0 .815 0 1.8v14.4c0 .985.793 1.8 1.75 1.8h10.5c.957 0 1.75-.815 1.75-1.8V5.4L8.75 0h-7zm0 1.8h6.125v4.5h4.375v9.9H1.75V1.8zm5.103 4.5c-.481 0-.842.336-.913.921-.07.584.212 1.606.703 2.554-.211.657-.422 1.24-.703 1.825-.912.291-1.754.729-2.105 1.167-.56.656-.28 1.094-.14 1.313.14.219.351.32.632.32.141 0 .281-.03.422-.102.562-.219 1.122-1.095 1.684-2.116.49-.146.982-.291 1.473-.364.49.583.984.95 1.405 1.095.49.146.911-.074 1.122-.585.14-.439.07-.802-.282-1.022-.421-.291-1.123-.292-1.965-.22-.28-.437-.56-.874-.77-1.313.35-1.094.49-2.042.35-2.626-.141-.51-.432-.847-.913-.847z"
});

var SvgPdfOutline = function SvgPdfOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf-outline.c975793e.svg";
export { ForwardRef as ReactComponent };